export const FB_FUNCTIONS_REGION = 'europe-west1';
